module.exports = __webpack_public_path__ + "img/negative-form.b4ba601c.svg";